import { render, staticRenderFns } from "./otherVideo.vue?vue&type=template&id=b75c909c&scoped=true&"
import script from "./otherVideo.vue?vue&type=script&lang=js&"
export * from "./otherVideo.vue?vue&type=script&lang=js&"
import style0 from "./otherVideo.vue?vue&type=style&index=0&id=b75c909c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75c909c",
  null
  
)

export default component.exports